import * as MediaAssetAPI from '@/api/media-asset';
import { useCurrentApp } from '@/stores/userDataStore';
import { useMediaAssetGeneration } from '@/hooks/useMediaAssetGeneration';
import { StabilityAIAspectRatio } from '@/types/media';
interface TextToImageProps {
  productId?: string;
  productTitle?: string;
  prompt: string;
  aspectRatio?: StabilityAIAspectRatio;
}

export const useTextToImage = () => {
  const { appKey, appUrl } = useCurrentApp();

  return useMediaAssetGeneration({
    mutationFn: async ({ productId, productTitle, prompt, aspectRatio }: TextToImageProps) =>
      MediaAssetAPI.generateImage({
        appKey,
        appUrl,
        imagePrompt: prompt,
        autogenerated: false,
        productId,
        productTitle,
        aspectRatio,
      }),
  });
};
